var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "select-strategy-import-from-idml",
        title: "Import IDML",
        centered: "",
        size: "lg",
        "ok-disabled":
          _vm.isLoading || (!_vm.selectedLayout && !_vm.newLayoutName.trim()),
      },
      on: { ok: _vm.handleImport, hide: _vm.reset },
    },
    [
      _c("Multiselect", {
        staticClass: "mb-3",
        attrs: {
          options: _vm.layouts,
          loading: _vm.isLoading,
          searchable: "",
          multiple: false,
          "custom-label": _vm.layoutLabel,
          "track-by": "id",
          placeholder: "Add to existing layout (optional)",
        },
        on: { "search-change": _vm.searchLayouts },
        scopedSlots: _vm._u(
          [
            _vm.layouts.length < _vm.layoutsTotalCount
              ? {
                  key: "afterList",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        { staticClass: "text-center p-2" },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: {
                                disabled: _vm.isLoading,
                                variant: "outline-primary",
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.getLayouts.apply(null, arguments)
                                },
                              },
                            },
                            [_vm._v("\n          Load More\n        ")]
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
          ],
          null,
          true
        ),
        model: {
          value: _vm.selectedLayout,
          callback: function ($$v) {
            _vm.selectedLayout = $$v
          },
          expression: "selectedLayout",
        },
      }),
      _vm._v(" "),
      !_vm.selectedLayout
        ? _c(
            "b-form-group",
            { attrs: { label: "New layout name" } },
            [
              _c("b-form-input", {
                model: {
                  value: _vm.newLayoutName,
                  callback: function ($$v) {
                    _vm.newLayoutName = $$v
                  },
                  expression: "newLayoutName",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }